/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, Plus, ExternalLink, Edit3, Trash2, ScanLine, BarChart3, Calendar, MapPin } from "lucide-react";
import { toast } from "sonner";
import { billetterieApi, formatApiError } from "@/lib/api";

function fmtDate(iso) { if (!iso) return "—"; try { return new Date(iso).toLocaleDateString("fr-FR"); } catch { return iso; } }

export default function AdminBilletterie() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    billetterieApi.adminList().then(setEvents).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const del = async (e) => {
    if (!window.confirm(`Supprimer l'événement "${e.name}" ? Les billets vendus seront conservés.`)) return;
    try { await billetterieApi.adminDelete(e.id); toast.success("Supprimé."); load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div data-testid="admin-billetterie">
      <header className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">Festivals & Événements</p>
          <h1 className="font-serif-luxe text-4xl md:text-5xl mt-3">Billetterie <span className="italic gold-text">en ligne.</span></h1>
          <p className="text-white/60 text-sm mt-3 max-w-2xl">
            Créez vos événements, configurez les tarifs (VIP, Adulte, Enfant, Famille…), vendez en ligne via Stripe et scannez les billets le jour J.
          </p>
        </div>
        <div className="flex gap-2">
          <Link to="/admin/billetterie/scan" data-testid="admin-bill-scan-link" className="btn-ghost-gold inline-flex items-center gap-2">
            <ScanLine size={14} strokeWidth={1.5} /> Scanner
          </Link>
          <Link to="/admin/billetterie/nouveau" data-testid="admin-bill-new" className="btn-gold inline-flex items-center gap-2">
            <Plus size={14} strokeWidth={1.5} /> Nouvel événement
          </Link>
        </div>
      </header>

      {loading ? <p className="text-white/55 italic">Chargement…</p>
        : events.length === 0 ? (
          <div className="card-luxe p-12 text-center">
            <Ticket size={36} strokeWidth={1} className="text-[#DCB457] mx-auto mb-4" />
            <p className="text-white/65 mb-3">Aucun événement.</p>
            <Link to="/admin/billetterie/nouveau" className="btn-ghost-gold inline-flex">Créer le premier</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {events.map((ev) => (
              <article key={ev.id} className="card-luxe overflow-hidden group" data-testid={`event-card-${ev.slug}`}>
                <div className="h-32 relative" style={{ background: ev.bg_gradient || `linear-gradient(135deg, ${ev.primary_color || "#FF3D71"}, ${ev.secondary_color || "#7C3AED"})` }}>
                  {ev.hero_image_url && <img src={ev.hero_image_url} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />}
                  <div className="absolute inset-0 bg-black/30" />
                  <div className="relative p-4 h-full flex flex-col justify-between">
                    <span className={`self-start text-[10px] uppercase tracking-[0.18em] px-2 py-0.5 ${ev.is_published ? "bg-emerald-500/90 text-black" : "bg-white/20 text-white"}`}>
                      {ev.is_published ? "Publié" : "Brouillon"}
                    </span>
                    <h3 className="text-white font-serif-luxe text-2xl drop-shadow">{ev.name}</h3>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-xs text-white/65 flex items-center gap-1.5"><Calendar size={11} /> {fmtDate(ev.date)} {ev.time && `· ${ev.time}`}</p>
                  {(ev.venue_name || ev.city) && <p className="text-xs text-white/55 flex items-center gap-1.5 mt-1"><MapPin size={11} /> {ev.venue_name || ev.city}</p>}
                  <p className="text-[11px] text-white/45 mt-2">{(ev.ticket_types || []).length} type(s) de billets</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    <Link to={`/admin/billetterie/${ev.id}`} data-testid={`event-detail-${ev.slug}`} className="text-[11px] uppercase tracking-[0.16em] border border-[#DCB457]/40 text-[#DCB457] px-2.5 py-1 hover:bg-[#DCB457]/10 inline-flex items-center gap-1">
                      <BarChart3 size={11} /> Détails
                    </Link>
                    <Link to={`/admin/billetterie/${ev.id}/edit`} className="text-[11px] uppercase tracking-[0.16em] border border-white/15 text-white/65 px-2.5 py-1 hover:bg-white/5 inline-flex items-center gap-1">
                      <Edit3 size={11} /> Éditer
                    </Link>
                    {ev.is_published && (
                      <a href={`/billetterie/${ev.slug}`} target="_blank" rel="noreferrer" className="text-[11px] uppercase tracking-[0.16em] border border-white/15 text-white/65 px-2.5 py-1 hover:bg-white/5 inline-flex items-center gap-1">
                        <ExternalLink size={11} /> Voir
                      </a>
                    )}
                    <button onClick={() => del(ev)} className="text-[11px] uppercase tracking-[0.16em] border border-red-400/30 text-red-300 px-2.5 py-1 hover:bg-red-500/10 inline-flex items-center gap-1">
                      <Trash2 size={11} />
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
    </div>
  );
}
